import { useApi } from "@shopexperts/shared";
import { useQuery } from "@tanstack/vue-query";
import { computed, type Ref, toValue } from "vue";

export function useSchema(schemaId: Ref<number> | number) {
  const api = useApi();

  const id = computed(() => toValue(schemaId));

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: computed(() => ['admin', 'page-schema', id.value]),
    queryFn: () => api.admin.pages.getSchema({ params: { id: id.value } }),
    enabled: computed(() => id.value > 0),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });

  return {
    schema: data,
    isLoading,
    error,
    refetch,
  };
}
